import { Button, Form, Input, Modal, Radio, Select } from "antd";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { FaTrash, FaPlus } from "react-icons/fa"; // Added FaPlus and FaTrash for add/remove icons
import { formatCurrency } from "../../../../../utils/formatCurrency";
import moment from "moment";

const { Option } = Select;
export const BulkUpdateRatesAndAvailabilityModal = (props) => {
  const {
    bulkInfo,
    bulkModalVisible,
    rooms,
    ratePlans,
    handleBulkModalOk,
    handleBulkModalCancel,
    handleAddDateRange,
    handleDateRangeChange,
    handleRemoveDateRange,
    setBulkInfo,
  } = props;
  const {
    bulkRoomId,
    bulkRatePlanId,
    bulkDateRanges,
    bulkAvailability,
    bulkRate,
    bulkCloseout,
    bulkCloseAll,
    bulkOpenAll,
    bulkMinimumStay,
    bulkMaximumStay,
    bulkRackRate,
  } = bulkInfo;

  // Shared handler for rate and rack rate fields
  const handleRateChange = (field, e) => {
    const rawValue = e.target.value.replace(/\./g, "");
    const value = parseInt(rawValue, 10);
    if (value > 0 || rawValue === "") {
      setBulkInfo((prev) => ({
        ...prev,
        [field]: rawValue,
      }));
    } else {
      Swal.fire(
        "Invalid Input",
        `${
          field === "bulkRate" ? "Rate (For Rate Plan)" : "Rack rate"
        } must be greater than 0.`,
        "warning"
      );
    }
  };

  return (
    <Modal
      title="Bulk Update Rates and Availability"
      visible={bulkModalVisible}
      onOk={handleBulkModalOk}
      onCancel={handleBulkModalCancel}
    >
      <Form layout="vertical">
        <Form.Item
          label={
            <span>
              <span className="text-danger">*</span>Select Room
            </span>
          }
        >
          <Select
            value={bulkRoomId}
            onChange={(value) =>
              setBulkInfo((prev) => ({
                ...prev,
                bulkRoomId: value,
              }))
            }
          >
            {rooms.map((room) => (
              <Option key={room._id} value={room._id}>
                {room.name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label={
            <span>
              <span className="text-danger">*</span>Select Rate Plan
            </span>
          }
        >
          <Select
            value={bulkRatePlanId}
            onChange={(value) =>
              setBulkInfo((prev) => ({
                ...prev,
                bulkRatePlanId: value,
              }))
            }
            allowClear
          >
            {ratePlans[bulkRoomId]?.map((plan) => (
              <Option key={plan._id} value={plan._id}>
                {plan.rateplanname}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label={<span>Rate (For Rate Plan)</span>}>
          <Input
            type="text"
            value={
              bulkRate
                ? formatCurrency(Number(bulkRate.toString().replace(/\./g, "")))
                : ""
            }
            onChange={(e) => handleRateChange("bulkRate", e)}
            disabled={
              bulkRatePlanId &&
              ratePlans[bulkRoomId]?.find((plan) => plan._id === bulkRatePlanId)
                ?.ratePlanSetup !== "Manual"
            }
            placeholder="Enter rate for rate plan (if applicable)"
          />
        </Form.Item>

        <Form.Item label="Rack Rate (Optional)">
          <Input
            type="text"
            value={
              bulkRackRate
                ? formatCurrency(
                    Number(bulkRackRate.toString().replace(/\./g, ""))
                  )
                : ""
            }
            onChange={(e) => handleRateChange("bulkRackRate", e)}
            placeholder="Enter rack rate (optional)"
          />
        </Form.Item>

        {bulkDateRanges.map((range, index) => (
          <div
            key={index}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Form.Item
              label={
                <span>
                  <span className="text-danger">*</span>
                  {`Date Range ${index + 1} - Start Date`}
                </span>
              }
              style={{ marginRight: "10px" }}
            >
              <Input
                type="date"
                value={range.startDate}
                min={moment().format("YYYY-MM-DD")}
                onChange={(e) =>
                  handleDateRangeChange(index, "startDate", e.target.value)
                }
              />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  <span className="text-danger">*</span>
                  {`Date Range ${index + 1} - End Date`}
                </span>
              }
              style={{ marginRight: "10px" }}
            >
              <Input
                type="date"
                value={range.endDate}
                min={moment().format("YYYY-MM-DD")}
                onChange={(e) =>
                  handleDateRangeChange(index, "endDate", e.target.value)
                }
              />
            </Form.Item>

            <Button
              type="danger"
              icon={<FaTrash />}
              onClick={() => handleRemoveDateRange(index)}
              style={{ marginTop: "8px" }}
            />
          </div>
        ))}

        <Button
          type="dashed"
          onClick={handleAddDateRange}
          icon={<FaPlus />}
          style={{ width: "100%", marginBottom: "20px" }}
        >
          Add Another Date Range
        </Button>

        <Form.Item label="Availability">
          <Input
            type="number"
            value={bulkAvailability}
            onChange={(e) =>
              setBulkInfo((prev) => ({
                ...prev,
                bulkAvailability: e.target.value,
              }))
            }
          />
        </Form.Item>

        <Form.Item label="Minimum Stay">
          <Input
            type="number"
            value={bulkMinimumStay}
            onChange={(e) =>
              setBulkInfo((prev) => ({
                ...prev,
                bulkMinimumStay: e.target.value,
              }))
            }
          />
        </Form.Item>

        <Form.Item label="Maximum Stay">
          <Input
            type="number"
            value={bulkMaximumStay}
            onChange={(e) =>
              setBulkInfo((prev) => ({
                ...prev,
                bulkMaximumStay: e.target.value,
              }))
            }
            placeholder="Enter maximum stay (optional)"
          />
        </Form.Item>

        <Form.Item label="Status">
          <Radio.Group
            value={
              bulkOpenAll
                ? "open_all"
                : bulkCloseAll
                ? "close_all"
                : bulkCloseout === true
                ? "close"
                : bulkCloseout === false
                ? "open"
                : "no_change"
            }
            onChange={(e) => {
              const val = e.target.value;
              if (val === "close_all") {
                setBulkInfo((prev) => ({
                  ...prev,
                  bulkCloseAll: true,
                  bulkCloseout: true,
                  bulkOpenAll: false,
                }));
              } else if (val === "open_all") {
                setBulkInfo((prev) => ({
                  ...prev,
                  bulkOpenAll: true,
                  bulkCloseAll: false,
                  bulkCloseout: false,
                }));
              } else if (val === "no_change") {
                setBulkInfo((prev) => ({
                  ...prev,
                  bulkOpenAll: false,
                  bulkCloseAll: false,
                  bulkCloseout: null,
                }));
              } else {
                setBulkInfo((prev) => ({
                  ...prev,
                  bulkOpenAll: false,
                  bulkCloseAll: false,
                  bulkCloseout: val === "close" ? true : false,
                }));
              }
            }}
          >
            <Radio value="no_change">No Change</Radio>
            <Radio value="open">Open these dates</Radio>
            <Radio value="close">Closeout these dates</Radio>
            <Radio value="close_all">Closeout all rate plans</Radio>
            <Radio value="open_all">Open all rate plans</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  );
};
